import 'twin.macro';
import React from 'react';
/* eslint-disable jsx-a11y/label-has-for,react/no-array-index-key */
import ButtonGroup from '../ButtonGroup';
import Tooltip2 from '@teetsh/app/src/components/Tooltip2';
import { lighten } from '@teetsh/app/src/utils/style/lighten';
import { darken } from '@teetsh/app/src/utils/style/darken';
import Button from '@teetsh/app/src/components/Buttons/Button';
import FormGroup from '../FormGroup';
import NumberInput from '@teetsh/app/src/components/Form/NumberInput';
import { css } from '@emotion/react';
import { Color } from '@teetsh/app/src/types/colors';
import tw from 'twin.macro';

interface ColoredButtonProps {
  color?: string;
  active?: boolean;
}

export const coloredButtonStyle = (p: ColoredButtonProps) => [
  p.color &&
    p.active &&
    css`
      background-color: ${lighten(0.1, p.color)} !important;
    `,
  p.color &&
    css`
      color: ${darken(p.active ? 0.3 : 0, p.color)} !important;
      font-weight: 700;
      border-color: ${darken(0.1, p.color)} !important;
    `,
];

export interface Option<T> {
  label: React.ReactNode | string;
  value: T;
  color?: Color | string;
  tooltip?: string;
}

export interface Props<T> {
  value: T;
  error?: string;
  touched?: boolean;
  withInput?: boolean;
  onChange: (value: T) => void;
  options: Option<T>[];
  label?: string;
  fill?: boolean;
  large?: boolean;
  small?: boolean;
  vertical?: boolean;
  canBeEmpty?: boolean;
  emptyValue?: T;
  disabled?: boolean;
  withoutMargin?: boolean;
  helperText?: string;
  className?: string;
  activeSemibold?: boolean;
}

// TODO Ce composant c'est du 💩
// il est très peu réutilisable
// et il beaucoup utilisé ... 😱

export default function ButtonsRadioMultiple<T>({
  value,
  onChange,
  error,
  emptyValue,
  withInput,
  touched,
  canBeEmpty,
  withoutMargin,
  large,
  vertical,
  fill,
  small,
  options,
  disabled,
  helperText,
  label,
  activeSemibold,
}: Props<T>) {
  return (
    <FormGroup
      label={label}
      withoutMargin={withoutMargin}
      error={touched ? error : undefined}
      helperText={error && touched ? error : helperText}
    >
      <div tw="flex flex-wrap">
        <ButtonGroup large={large} vertical={vertical} fill={fill}>
          {options.map((option, index) => {
            const isActive = value === option.value;
            const ButtonToDisplay = (
              <Button
                key={index}
                css={[
                  coloredButtonStyle({
                    color: option.color,
                    active: isActive,
                  }),
                  isActive &&
                    !option.color &&
                    css`
                      ${tw`bg-brand-moderate text-brand-intense`}
                    `,
                  isActive && activeSemibold && tw`font-semibold`,
                ]}
                large={large}
                small={small}
                disabled={disabled}
                aria-label={
                  typeof option.label === 'string'
                    ? option.label
                    : `${option.value}`
                }
                active={isActive}
                onClick={() => {
                  if (isActive && canBeEmpty) {
                    return onChange(emptyValue as any);
                  }
                  return onChange(option.value);
                }}
              >
                {option.label}
              </Button>
            );
            if (option.tooltip) {
              return (
                <Tooltip2 key={index} label={option.tooltip}>
                  {ButtonToDisplay}
                </Tooltip2>
              );
            }
            return ButtonToDisplay;
          })}
        </ButtonGroup>
        {withInput && (
          <div tw="w-24 ml-3">
            <NumberInput
              rightElement={
                <div tw="flex justify-center items-center h-full px-0.5">
                  min
                </div>
              }
              value={value as any}
              onChange={onChange as any}
              fractionDigits={0}
              min={0}
            />
          </div>
        )}
      </div>
    </FormGroup>
  );
}
